import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ChatbotService } from '../shared/services/chatbot.service';
import { ChatbotDialogComponent } from '../chatbot/chatbot-dialog/chatbot-dialog.component';
import { ChatbotDialogUserComponent } from './chatbot-dialog-user/chatbot-dialog-user.component';
import { ChatbotDialogBotComponent } from './chatbot-dialog-bot/chatbot-dialog-bot.component';

@NgModule({
  imports: [
    CommonModule, 
    FormsModule
  ],
  declarations: [
    ChatbotDialogComponent,
    ChatbotDialogUserComponent,
    ChatbotDialogBotComponent
  ],
  exports: [ChatbotDialogComponent],
  providers: [ChatbotService]
})
export class ChatbotModule { }



// WEBPACK FOOTER //
// ./src/app/chatbot/chatbot.module.ts